<script setup>
import { inject, ref, onMounted } from 'vue';
import AutoComplete from 'primevue/autocomplete';

const { typeDonnee, autoFocus } = defineProps({
    typeDonnee: Object,
    autoFocus: Boolean
});

const texte = defineModel('texte', {
    type: String
});

const emit = defineEmits(['validation', 'annulation']);

const getListeValeurs = inject('getListeValeurs');
const getObjets = inject('getObjets');

const composant = ref(null);
const suggestionsValeur = ref([]);

onMounted(() => {
    if (autoFocus) {
        composant.value.$refs.focusInput.focus();
    }
});

function mettreAJourTexte(event) {
    texte.value = event.target.value;
}

function mettreAJourSuggestions(event) {
	const texteSaisi = event.query.toLowerCase();
	switch(typeDonnee?.classe) {
		case 'OBJET':
			const objets = getObjets(typeDonnee.id);
			suggestionsValeur.value = objets.filter(objet => objet.toLowerCase().startsWith(texteSaisi));
			break;
		case 'VALEUR_LISTE':
			const valeurs = getListeValeurs(typeDonnee.id).valeurs;
			suggestionsValeur.value = valeurs.map(valeur => valeur.nom).filter(val => val.toLowerCase().startsWith(texteSaisi));
			break;
		default:
			suggestionsValeur.value = [];
	}
}

function valider() {
    if (suggestionsValeur.value.length !== 0) {
        if (composant.value.findSelectedOptionIndex() != -1) {
            texte.value = suggestionsValeur.value[composant.value.findSelectedOptionIndex()]
        }
    }
    emit('validation');
}

function annuler() {
    emit('annulation');
}

</script>

<template>
    <AutoComplete
        class="texte-saisie-valeur"
        ref="composant"
        v-model="texte" 
        :suggestions="suggestionsValeur" 
        :min-length="0"
        :delay="0"
        :fluid="true"
        :completeOnFocus="true"
        :autoOptionFocus="false"
        @input="mettreAJourTexte"
        @complete="mettreAJourSuggestions"
        @keydown.enter.prevent.stop="valider"
        @keydown.escape.prevent.stop="annuler()" 
        @mousedown.stop=""
        @dragstart.stop.prevent=""
        @dragleave.stop.prevent=""
        @blur="annuler()" />
</template>

<style scoped>

</style>